<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #description>
            <div>
                欄位底色： 
                <span :style="{'background-color': '#FFFF00'}">時雨量達 40毫米以上</span>
            </div>
        </template>

        <template #filter_condition_options>
            <MonitorOptionSet 
                ref="monitor_option_set"
                :option_set="option_set"
                @filter_data="filter_data" 
            />
        </template>
	
        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :show_download_pdf_btn="true"
                :table_label_function="calc_accumulated_precp_level"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template #table_description>
                    <span> 說明："--"標示，顯示該欄位無資料。</span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import {
        generate_variable_options,
        update_option_set_from_local_storage,
        combine_new_variable_options,
        update_current_option_value,
    } from '@/utils/monitor/option.js'
    import { covert_to_float } from '@/utils/monitor/common_tool.js'
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorOptionSet from "../monitor_option_set.vue"
    import QpeDatatable from "../qpe_datatable.vue"

    export default {
        name: 'ThbMileageRainfallDaily',
        
        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorOptionSet, 
            QpeDatatable
        },
        
        mixins: [monitor_mixin],
        
        data() {
            return {
                header: [],
                table_data: [],
                default_value: 262,
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_route: '全部',


                display_all_office: '所有養護工程分局',
                display_all_branch: '所有工務段',
                local_storage_option_name: 'mileage_61_rainfall_daily_option'
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        watch: {
            immutable_table_data: {
                handler() {
                    if (this.immutable_table_data) {
                        this.init_option_set()
                        this.option_set = update_option_set_from_local_storage(this.option_set , this.local_storage_option_name)
                    }
                },
                deep: true
            },
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = data;
                this.header = header;
            },

            init_option_set() {  
                const basic_variable_options = [
                    { default_value: this.display_all_office, json_key:'養護工程分局', label: 'office' },
                    { default_value: this.display_all_branch, json_key:'工務段', label: 'branch' },
                ]

                const variable_options = generate_variable_options(basic_variable_options, this.immutable_table_data)

                if (this.option_set.length === 0) {
                    this.option_set = [...variable_options]
                } else {
                    this.option_set = combine_new_variable_options(this.option_set, variable_options)
                    this.$refs.monitor_option_set.change_option_set()
                }
            },
            
            filter_data(filtered_cond, change_condition_label) {
                const update_current_value_by_filtered_cond = update_current_option_value(filtered_cond);
                this.option_set = this.option_set.map(update_current_value_by_filtered_cond)
                if (change_condition_label === 'office') {
                    this.option_set[1].current_option_value = this.display_all_branch
                    filtered_cond['branch'] = this.display_all_branch
                }

                const compare_office = filtered_cond['office'] === this.display_all_office ? '' : filtered_cond['office'];
                const compare_branch = filtered_cond['branch'] === this.display_all_branch ? '' : filtered_cond['branch'];
        
                const filtered_data = this.immutable_table_data.filter(item => {
                    return (
                        item['養護工程分局'].includes(compare_office) && item['工務段'].includes(compare_branch)
                    )
                })
                this.table_data = filtered_data
                this.generate_branch_option(filtered_cond['office'])

                // 把目前選擇的 option 存起來
                localStorage.setItem('mileage_61_rainfall_daily_option', JSON.stringify(filtered_cond))
            },

            generate_branch_option (office) {
                const filter_towns_by_office = item => item['養護工程分局'] === office
                const get_branch = item => item['工務段']
                const filtered_towns_options = office === this.display_all_office ? this.immutable_table_data : this.immutable_table_data.filter(filter_towns_by_office)
                const towns_options = filtered_towns_options.map(get_branch)
                this.option_set[1].option_array = [this.display_all_branch, ...new Set(towns_options)]
            },

            calc_accumulated_precp_level(row_data) {
                const hour_dot_1 = covert_to_float(row_data['1小時格點QPE'])
                const hour_averge_1 = covert_to_float(row_data['1小時平均QPE'])
                const hour_max_1 = covert_to_float(row_data['1小時最大QPE'])
                if (hour_dot_1 >= 40 || hour_averge_1 >= 40 || hour_max_1 >= 40) {
                    return 'row_head_border custom_yellow'
                }
            }
        },
    }
</script>

<style>
</style>